"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var collapseSelectedBlocks_1 = require("../utils/collapseSelectedBlocks");
/**
 * Change direction for the blocks/paragraph at selection
 * @param editor The editor instance
 * @param direction The direction option:
 * Direction.LeftToRight refers to 'ltr', Direction.RightToLeft refers to 'rtl'
 */
function setDirection(editor, direction) {
    editor.focus();
    editor.addUndoSnapshot(function (start, end) {
        collapseSelectedBlocks_1.default(editor, function (element) {
            element.setAttribute('dir', direction == 0 /* LeftToRight */ ? 'ltr' : 'rtl');
            element.style.textAlign = direction == 0 /* LeftToRight */ ? 'left' : 'right';
        });
        editor.select(start, end);
    }, "Format" /* Format */);
}
exports.default = setDirection;
//# sourceMappingURL=setDirection.js.map